const ROUNDING_THRESHOLD = 1000;

export const formatResultsCount = (total: number): string => {
	if (total < ROUNDING_THRESHOLD) return total.toLocaleString('en-US');

	const rounded = Math.floor(total / ROUNDING_THRESHOLD) * ROUNDING_THRESHOLD;
	return `${rounded.toLocaleString('en-US')}+`;
};
